"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BillItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = require("react-native-svg");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/en-gb");
var _content = require("@sart/content");
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _excluded = ["invoice", "onPress"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function BillItem(props) {
  var invoice = props.invoice,
    onPress = props.onPress,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var content = (0, _content.useContent)();
  var language;
  if (client.cache.language === 'en') {
    language = 'en-gb';
  } else if (client.cache.language === 'es') {
    language = 'es-us';
  }
  var formatDate = function formatDate(date, language) {
    if (date) {
      var formatted = (0, _moment["default"])(date).utc().locale(language).format('ddd D MMM');
      var elements = formatted.split('.').join('').split(' ');
      elements[0] = elements[0][0].toUpperCase() + elements[0].slice(1);
      elements[2] = elements[2][0].toUpperCase() + elements[2].slice(1);
      return elements.join(' ');
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: styles.container,
    onPress: onPress
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.placeholder
  }, invoice.category === 'CLOSED' && /*#__PURE__*/_react["default"].createElement(_icons.Tick, null), invoice.category === 'CURRENT' && /*#__PURE__*/_react["default"].createElement(_icons.AlertOctagon, {
    color: _styles.colors.white,
    size: 48
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.body
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.header
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.title
  }, formatDate(invoice.invoiceDate, language)), /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    style: styles.title,
    value: invoice.outstandingAmountDue,
    code: invoice.currency
  })), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.itemSubHeaderItemStyle
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.description
  }, content.viewBill.clickToView))));
}
BillItem.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 72,
    width: '100%',
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.subtle,
    overflow: 'hidden'
  },
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.srGreen
  },
  body: {
    flex: 1,
    padding: 12
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 16
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.exisBlue
  }),
  description: {
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.common
  },
  itemSubHeaderItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  productImageMobile: {
    // marginTop: 12,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center'
    // backgroundColor: backgroundColors.exisOrange,
  },
  productImageWeb: {
    width: 72
  }
});